import { __, sprintf } from '@wordpress/i18n';
import { useMemo } from '@wordpress/element';
import { generateFontSizeHint } from './utils';
import { StyledCustomSelectControl } from './styles';
import { jsx as _jsx } from "react/jsx-runtime";
const DEFAULT_OPTION = {
  key: 'default',
  name: __('Default'),
  value: undefined
};
const FontSizePickerSelect = props => {
  const {
    fontSizes,
    value,
    valueMode = 'literal',
    onChange
  } = props;
  const options = [DEFAULT_OPTION, ...fontSizes.map(fontSize => {
    const hint = generateFontSizeHint(fontSize);
    return {
      key: fontSize.slug,
      name: fontSize.name || fontSize.slug,
      value: fontSize.size,
      hint
    };
  })];
  const selectedOption = useMemo(() => {
    if (value === undefined) {
      return DEFAULT_OPTION;
    }

    // If valueMode is 'slug', find by slug
    if (valueMode === 'slug') {
      const optionBySlug = options.find(option => option.key === value);
      if (optionBySlug) {
        return optionBySlug;
      }
    }

    // If valueMode is 'literal', find by value (size)
    return options.find(option => option.value === value) ?? DEFAULT_OPTION;
  }, [value, valueMode, options]);
  return /*#__PURE__*/_jsx(StyledCustomSelectControl, {
    className: "components-font-size-picker__select",
    label: __('Font size'),
    hideLabelFromVision: true,
    describedBy: sprintf(
    // translators: %s: Currently selected font size.
    __('Currently selected font size: %s'), selectedOption.name),
    options: options,
    value: selectedOption,
    showSelectedHint: true,
    onChange: ({
      selectedItem
    }) => {
      // Find the corresponding FontSize object
      const matchingFontSize = selectedItem.key === 'default' ? undefined : fontSizes.find(fontSize => fontSize.slug === selectedItem.key);
      onChange(selectedItem.value, matchingFontSize);
    }
  });
};
export default FontSizePickerSelect;